import React from 'react';

import { ReactComponent as IconPlus } from 'icons/icon-plus.svg';
import { ReactComponent as IconCheck } from 'icons/icon-checkmark.svg';
import { CheckButton } from 'components/customlists/AddToList/styles';
import styled from 'styled-components/macro';
import colors from 'styles/themes/colors';

const Spinner = styled.div<{ forward: boolean }>`
  width: 13px;
  height: 13px;
  border: 2px solid;
  border-color: ${colors.NightBlue} transparent ${colors.LightNightBlue}
    transparent;
  border-radius: 50%;
  animation: spin 1.2s linear infinite;
  animation-direction: ${({ forward }): string =>
    forward ? 'normal' : 'reverse'};
`;

interface IAddToListButtonProps {
  onClick: () => void;
  icon?: string;
  loading?: boolean;
  forward?: boolean;
}

const AddToListButton: React.FC<IAddToListButtonProps> = (props) => {
  const { onClick, icon = 'plus', loading = false, forward = true } = props;
  return (
    <CheckButton
      data-addtolist
      variant="secondary"
      display="flex"
      alignItems="center"
      justifyContent="center"
      onClick={onClick}
      px={2}
      py={2}
    >
      {loading && <Spinner forward={forward} />}
      {!loading && (icon === 'plus' ? <IconPlus /> : <IconCheck />)}
    </CheckButton>
  );
};

export default AddToListButton;
